{
  "discounts-list-page": {
    "header": {
      "title": "Discounts",
      "description": "Discounts let you set up promotions for your B2B customers that work alongside any price list rules you have set up.",
      "footer": "Learn more about the SparkLayer Discount Engine",
      "actions": {
        "create": "Create Discount",
        "prioritise": "Manage Priorities"
      }
    },
    "empty": {
      "title": "You have no discounts set up yet",
      "body": "Let's get started and create your first one!",
      "actions": {
        "create": "Create Discount"
      },
      "suggestions": {
        "title": "Or start with a ready-made discount (you can edit these later)",
        "percentage": {
          "title": "20% off with coupon code 20-OFF",
          "description": "Apply a 20% discount off the sub-total using a coupon"
        },
        "fixed": {
          "title": "{discount} off on orders over {amount}",
          "description": "Apply a fixed-amount discount on a sub-total threshold",
          "name": "100 off orders over 1000"
        }
      },
      "learn_more": "Learn more about types of discounts available"
    },
    "help": {
      "setup": {
        "title": "Setup coupon codes",
        "body": "Learn how to begin using coupon codes that apply a discount to an order (e.g. 20% off)",
        "action": "Learn more"
      },
      "configure": {
        "title": "Configure order-level discounts",
        "body": "Setup discounts that are applied based on specific order criteria (e.g. 10% off orders over {amount})",
        "action": "Learn more"
      }
    }
  },
  "discount-create-page": {
    "header": {
      "title": "Create Discount",
      "description": "Configure your discount requirements below."
    },
    "status": {
      "success": {
        "create_succeeded": "The discount has been created successfully."
      },
      "errors": {
        "duplicate_slug": "Sorry, this Discount Handle (ID) has already been used. Please try again with a unique one."
      }
    }
  },
  "discount-edit-page": {
    "header": {
      "title": "Edit Discount",
      "description": "Configure your discount requirements below."
    },
    "status": {
      "success": {
        "update_succeeded": "The discount has been updated successfully."
      }
    }
  },
  "discount-builder": {
    "actions": {
      "create": "Create Discount",
      "update": "Update Discount"
    }
  }
}
